import { BreadCrumbProvider } from '../../component/ui/breadcrumb'
import React, { useEffect } from 'react'
import { Layout } from '../distributorPage/Layout'
import { InvestorInfo } from './InvestorInfo'
import { useDispatch, useSelector } from 'react-redux'
import { getDistributorInfo } from '../../utils/util'
import { setDistributorInfo } from '../../context/actions/distributorInfoAction'

const Distributor = () => {
  const dispatch=useDispatch()
  const userInfo =useSelector(state=>state.user)
  const handleGetDistributorInfo=async()=>{
    // dispatch(loaderSet(true))
    const payload={
      user_email: userInfo?.email,
      user_type: userInfo?.user_type,
      user_id: userInfo?.user_id
    }
    // const payload={
    //   user_email:"madhankumarraja06@gmail.com",
    //   user_type:"distributor",
    //   user_id:"user_a6053e20",
    // }
    try {
      const response = await getDistributorInfo(payload);
      console.log("response for distributor info ", response);
      if(response){
        dispatch(setDistributorInfo(response?.data));
        // setScheme(response?.schemes.map((item,index)=>(`${item.scheme_name}-${item.scheme_class}`)))
        // if(scheme?.length>0){
        //   setSelectedSchemeOptions(scheme)
        //   console.log("setSelectedSchemeOptions(scheme)",scheme)

        // }
        
        // dispatch(loaderSet(false))
      }
    } catch (error) {
      console.log("Error in view distributor info API", error);
      // dispatch(loaderSet(false))
    }
  }

  useEffect(()=>{
    handleGetDistributorInfo()
   
  },[])

  return (
   <BreadCrumbProvider>
   <Layout/>
  
   </BreadCrumbProvider>
  )
}

export default Distributor
